import React from "react";
const ServiceSection = () => {
  return (

    <section id="services" className="services section-bg ">
      <div className="container" data-aos="fade-up">

        <div className="section-title">
          <h2>Services</h2>
         </div>

        <div className="row">
          <div className="col-md-12">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-motherboard"></i>
              <h4><a href="javascript:void(0)">Motherboard Repair</a></h4>
            
              <p>The motherboard is the most critical component in a laptop. And also the most difficult to repair, by far. If you know, or suspect, that your laptop has a faulty motherboard, you should be very careful who you trust with the repair. It requires a specialized skill set, and the highest level of repair workmanship. Progress solution has a trained, experienced technicians for just this!</p> 
              </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-eraser"></i>
              <h4><a href="javascript:void(0)">Service/Cleaning</a></h4>
              <p>Full laptop service like dust cleaning, thermal paste change, internal fan cleanup, refix loose connections etc. <br/> Cleaning laptop thoroughly along with RAM, connectors, and keypad</p>
            </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-laptop"></i>
              <h4><a href="javascript:void(0)">OS installation</a></h4>
              <p>Installation/Upgradation of Operating system <br/> Operating systems covered: Windows, macOS <br/>Only genuine OS installation supported</p>
            </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-tools"></i>
              <h4><a href="javascript:void(0)">Laptop body fabrication</a></h4>
              <p>Laptop body fabrication is the process of fixing the two broken body parts of your laptop which is damaged or broken. Laptop Fabrication helps you to get laptop broken parts to fix together.</p>
            </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="500">
              <i className="bi bi-pc-display-horizontal"></i>
              <h4><a href="javascript:void(0)">And much more services is also available</a></h4>
              <p>Diagnosis <br/>Screen, Battery, Speaker, Fan and Keyboards Replacement <br/> RAM, SSD and Hard Disk Upgrade, etc</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServiceSection;
